import ToggleItem from './toggle_item';

export default class Textwrap extends ToggleItem {
  constructor() {
    super('textwrap');
  }
}
